var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { validators } from "../Logic/Validators";
import { FormModel } from "./FormModel";
import { minPasswordLength, passwordExpiryInDays } from "healthex-common/constants";
export class AdminPasswordSettingsViewModel {
    constructor(opts) {
        this.formModel = new FormModel({
            passwordExpiryInDays: passwordExpiryInDays,
            minPasswordLength: minPasswordLength,
        }, ["passwordExpiryInDays", "minPasswordLength"]);
        this.organization = NOT_LOADED;
        this.validateMinLength = (minLength) => {
            return (value) => {
                if (value < minLength) {
                    return false;
                }
                return true;
            };
        };
        this.organizationsManager = opts.container.organizationsManager;
        this.onSave = opts.onSave;
        void this.loadOrganization();
    }
    validateInput() {
        this.formModel.clearErrors();
        const { notNull } = validators;
        const f = this.formModel;
        f.validateField("minPasswordLength", this.validateMinLength(8), "Enter password length. Minimum length is 8.");
        f.validateField("passwordExpiryInDays", this.validateMinLength(1), "Enter password expiry in days. Minimum value is 1.");
        return !f.hasErrors();
    }
    async save() {
        if (this.organization === NOT_LOADED || !this.organization)
            return;
        if (!this.validateInput())
            return;
        const { passwordExpiryInDays, minPasswordLength } = this.formModel.input;
        const updatedOrganizationDetailsInput = {
            type: this.organization.type,
            passwordConfiguration: {
                passwordExpiryInDays,
                minPasswordLength,
            },
        };
        await this.organizationsManager.updateOrganizationDetails(this.organization.id, updatedOrganizationDetailsInput);
        await this.loadOrganization();
        this.onSave();
    }
    async loadOrganization() {
        var _a, _b, _c, _d;
        const organization = this.organizationsManager.myOrganization.value;
        if (organization && organization !== NOT_LOADED) {
            this.organization = organization;
            this.formModel.updateInput({
                minPasswordLength: (_b = (_a = organization.passwordConfiguration) === null || _a === void 0 ? void 0 : _a.minPasswordLength) !== null && _b !== void 0 ? _b : minPasswordLength,
                passwordExpiryInDays: (_d = (_c = organization.passwordConfiguration) === null || _c === void 0 ? void 0 : _c.passwordExpiryInDays) !== null && _d !== void 0 ? _d : passwordExpiryInDays,
            });
        }
    }
}
__decorate([
    observable
], AdminPasswordSettingsViewModel.prototype, "organization", void 0);
